import axiosInstance from "./axiosInstance";

const actualizarMorosidad = async (adminId, titularId, razon) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_BASE_URL}/actualizarMorosidad`,
      {
        adminId,
        titularId,
        razon,
      },
      { withCredentials: true }
    )
    .then((res) => res)
    .catch((err) => err);
};

export default actualizarMorosidad;
